<!-- 销售退货记账操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="val => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="150px" id="mainInfo" class="baseForm" size="mini"
                                        ref="sendDataInfo" :model="sendDataInfo" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <!-- 销售订单号 -->
                                                <el-input v-if="formOneValue.entityField == 'rgcamId'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    @focus="openExComponents(formOneValue.extractId)"></el-input>
                                                <!-- 退回单位 -->
                                                <el-input v-else-if="formOneValue.entityField == 'cmId'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo.cmName"></el-input>
                                                <!-- 业务员 -->
                                                <el-input v-else-if="formOneValue.entityField == 'opmId'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo.opmName"></el-input>
                                                <!-- 业务部门 -->
                                                <el-input v-else-if="formOneValue.entityField == 'depId'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo.depName"></el-input>
                                                <!-- 对方业务员 -->
                                                <el-input v-else-if="formOneValue.entityField == 'salesId'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo.salesName"></el-input>
                                                <!-- 记账日期 -->
                                                <df-date v-else-if="formOneValue.fieldType == 'date'"
                                                    :isdisabled="formOneValue.isChange == 0"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <!-- 备注 -->
                                                <el-input type="textarea" :maxlength="$store.state.inputLength"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-else-if="formOneValue.entityField == 'rgbkmRemark'"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <el-input :disabled="formOneValue.isChange == 0" v-else
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'"
                                                :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'opmId'">{{
                                                    sendDataInfo.opmName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'cmId'">{{
                                                    sendDataInfo.cmName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'depId'">{{
                                                    sendDataInfo.depName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'salesId'">{{
                                                    sendDataInfo.salesName }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <span
                                                    v-else-if="formOneValue.fieldType == 'formatter'">{{ getValue(sendDataInfo[formOneValue.entityField],
                                                        formOneValue.entityField, formOneValue.fieldType,
                                                    formOneValue.formatterContent)}}</span>

                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细 -->
                                    <el-form :inline="true" size="mini">
                                        <el-table :data="sendDataInfo.desuRgbkAccDetailAdds" border style="width: 100%"
                                            :height="mxHeight" class="toReviewTable" ref="multipleTable" size="mini">
                                            <el-table-column v-for="(formOneValue, formOneKey) in mxForm"
                                                :key="formOneKey" :prop="formOneValue.entityField"
                                                :label="formOneValue.showField" show-overflow-tooltip
                                                :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <!-- 显示通用名称 -->
                                                    <span v-if="formOneValue.entityField == 'bgmId'">
                                                        {{ sendDataInfo.desuRgbkAccDetailAdds[scope.$index].bgmName }}
                                                    </span>
                                                    <!-- 有效期 -->
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span
                                                            v-if="sendDataInfo.desuRgbkAccDetailAdds[scope.$index][formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField])
                                                            }}
                                                        </span>
                                                    </span>
                                                    <!-- 生产日期 -->
                                                    <!-- 显示库房 -->
                                                    <span v-else-if="formOneValue.entityField == 'stId'">
                                                        {{ sendDataInfo.desuRgbkAccDetailAdds[scope.$index].stName }}
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a
                                                            @click="toDetail(sendDataInfo.desuRgbkAccDetailAdds[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.desuRgbkAccDetailAdds[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <span v-else>
                                                        {{
                                                            sendDataInfo.desuRgbkAccDetailAdds[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>
                                </div>
                                <!-- 辅助信息 -->
                                <div v-if="scope.index == 1">
                                    <el-form label-width="150px" class="baseForm" size="mini" :model="sendDataInfo"
                                        ref="sendDataInfo" :show-message="false">
                                        <el-row>
                                            <el-form-item :label="formOneValue.showField"
                                                :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                <df-date
                                                    v-if="formOneValue.fieldType == 'date' && wosupinfor[formOneValue.entityField]"
                                                    :isdisabled="formOneValue.isChange == 0"
                                                    v-model="wosupinfor[formOneValue.entityField]"></df-date>
                                                <!-- 货主 -->
                                                <el-input :disabled="formOneValue.isChange == 0"
                                                    v-else-if="formOneValue.entityField == 'coId'"
                                                    v-model.trim="wosupinfor.coName"></el-input>
                                                <el-input :disabled="formOneValue.isChange == 0" v-else
                                                    v-model.trim="wosupinfor[formOneValue.entityField]">
                                                </el-input>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印</el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">保存</el-button>
                    </div>
                    <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                        <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                            <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData"
                @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
    name: 'salesReturnAccountAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionScheme },
    data() {
        //这里存放数据
        return {
            dialogFormVisible: false,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑'
            },
            sendDataInfo: {
                "rgbkmRapdate": 0,
                "accounter": 0,
                "cmId": 0,
                "cmName": "",
                "depId": 0,
                "depName": "",
                "isWms": 0,
                "opmId": 0,
                "opmName": "",
                "totalCount": 0,
                "totalMoney": 0,
                "totalNumber": 0,
                "rgcamId": "",
                "woamRemark": "",
                "woamSaledate": 0,
                "desuRgbkAccDetailAdds": [
                    {
                        "batchno": "",
                        "bgmId": 0,
                        "bgmName": "",
                        "bgsId": 0,
                        "expidate": 0,
                        "gross": 0,
                        "manufacturer": "",
                        "money": 0,
                        "outRate": 0,
                        "placeorigin": "",
                        "price": 0,
                        "prodate": 0,
                        "psmoney": 0,
                        "psprice": 0,
                        "returnNum": 0,
                        "rowno": 0,
                        "spec": "",
                        "sterBatchno": "",
                        "woadId": 0,
                        "woadPnumber": 0,
                        "woadWcost": 0,
                        "wobkedId": 0,
                        "wobkedReserves1": "",
                        "wobkedReserves2": "",
                        "wobkedReserves3": "",
                        "wobkedReserves4": "",
                        "wobkedReserves5": "",
                        "wobkedReserves6": "",
                        "wobkemId": "",
                        "worcdId": 0
                    }
                ],
                "wobkemExecuterName": "",
                "wobkemId": "",
                "wobkemReserves1": "",
                "wobkemReserves2": "",
                "wobkemReserves3": "",
                "wobkemReserves4": "",
                "wobkemReserves5": "",
                "wobkemReserves6": "",
                "wobkemState": 0,
                "worcmId": "",
                "wosiId": 0,
                totalCount: 0,
                totalMoney: 0,
                totalNumber: 0,
                salesId: '',
                salesName: '',
                rgbkmRemark: ''

            },
            wosupinfor: {//货主信息
                "coId": 0,
                "coName": "",
                "credit": "",
                "dismode": "",
                "payMethod": "",
                "settleMethod": "",
                "wosiId": 0,
                "wosiReserves1": "",
                "wosiReserves2": "",
                "wosiReserves3": "",
                "wosiReserves4": "",
                "wosiReserves5": "",
                "wosiReserves6": ""
            },
            // reviewDialogFormVisible:false,
            review: {
                twoAudit: '',
                pwd: ''
            },
            reviewRules: {
                twoAudit: [
                    { required: true, message: '请选择记账人', trigger: 'change' }
                ],
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ]
            },
            showTabs: '',
            formDataList: [],
            dictionariesData: {},
            userOneList: [],

            reviewUserInfo: {
                opmId: '',
                passWord: '',
                selectIndex: 0,
            },
            isReviewReq: false,
            actionIndex: '',
            ishowRew: true,
            exTitle: '',//缓存提取
            exWidth: '',
            DialogExtract: false,
            ppId: 'rgcamId',
            exId: '',
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: []
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.desuRgbkAccDetailAdds': {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.desuRgbkAccDetailAdds = newValue
                // console.log(newValue)
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 触发提取方案
        openExComponents(e) {
            // console.log(e);
            this.exId = e;
            this.DialogExtract = true;
        },

        // 获取 提取单数据
        async getExData(res) {
            let val = JSON.parse(JSON.stringify(res))
            console.log('提取', val);
            if (val != "" || val != undefined) {
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        this.sendDataInfo.desuRgbkAccDetailAdds = val.arrlistbychen;
                    } else {
                        this.sendDataInfo[key] = val[key];
                    }
                }
                let responseData = await this.$http.getDesuRgApplySupInfo({ ids: [val.rgaiId] })
                if (responseData && responseData.status == 200) {
                    this.wosupinfor = responseData.result;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    })
                }
                this.sendDataInfo.rgbkmRapdate = new Date().getTime()

                // console.log(this.sendDataInfo);
            } else {
                this.$message({
                    message: '未拿到数据',
                    type: 'error'
                })
            }
            this.DialogExtract = false
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },

        //保存
        async sendDataAction(formName) {
            let flag = false
            this.$refs[formName].validate((valid) => {
                if (valid) {

                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;
            if (!this.sendDataInfo.rgcamId) {
                this.$message({
                    message: '请选择销售单进行记账',
                    type: 'error'
                });
                return false
            }
            if (!this.sendDataInfo.rgbkmRapdate) {
                this.$message({
                    message: '请选择记账日期',
                    type: 'error'
                });
                return false
            }
            var responseData = await this.$http.setSalesReturnAccount(this.sendDataInfo)
            if (responseData && responseData.status == 200) {
                this.$emit('drawerCancel')
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        //初始
        init() {
            for (let key in this.sendDataInfo) {
                if (Object.hasOwnProperty.call(this.sendDataInfo, key)) {
                    this.sendDataInfo[key] = ''
                }
            }
            for (const key in this.wosupinfor) {
                if (Object.hasOwnProperty.call(this.wosupinfor, key)) {
                    this.wosupinfor[key] = ''
                }
            }
            this.sendDataInfo.desuRgbkAccDetailAdds = []
        },

        //取消
        initActionBox(formName) {
            this.$confirm('确定取消新增吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('drawerCancel')
                this.init()
                this.$refs[formName].resetFields();
            }).catch(() => { })
        },


        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init()
            if (this.dataActionBox.actionType == 0) {
                this.sendDataInfo.rgbkmRapdate = this.$moment().valueOf();
                this.dataActionBox.boxTitle = '新增销售退货记账单'
                this.dataActionBox.openMode = 'ltr'
            } else if (this.dataActionBox.actionType == 2) {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                    if (key == 'desuRgbkAccDetailVos') {
                        this.sendDataInfo.desuRgbkAccDetailAdds = dataInfo[key]
                    } else if (key == 'desuRgapplySupInfo') {
                        for (let k in dataInfo[key]) {
                            this.wosupinfor[k] = dataInfo[key][k]
                        }
                    }
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rgbkmId)
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            })
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = [{ entityField: "desuRgbkAccDetailAdds" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
        // this.getSpecialUser()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {

    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.mb {
    margin-bottom: 0;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
</style>